import { Injectable } from '@angular/core';

import lodash from 'lodash';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ContextModel } from '@bayclubs/group-classes-employee-api';
import { ManagementHttpClient } from './management-http-client';

@Injectable({
    providedIn: 'root',
})
export class ContextApiService {
    constructor(private http: ManagementHttpClient) {}

    public get(): Observable<ContextModel> {
        return this.http.get<ContextModel>('context', false).pipe(
            shareReplay(1),
            map(context => {
                context.categories.sort(
                    (a, b) => a.classTypeName.localeCompare(b.classTypeName) || a.name.localeCompare(b.name)
                );
                return lodash.cloneDeep(context);
            })
        );
    }
}
